const mb = 1048576

export default {
  namespaced: true,
  state: {
    fileMaxSizeMb: 20
  },
  getters: {
    fileMaxSize: state => mb * state.fileMaxSizeMb
  }
}



// WEBPACK FOOTER //
// ./src/store/limit/index.js